"use client";

import { useEffect } from "react";
import { pushToDataLayer } from "./pushToDataLayer";

export const NotFoundTracker: React.FC = () => {
  useEffect(() => {
    pushToDataLayer({ event: "404_error", pathname: window.location.pathname });
  }, []);

  return null;
};
